import {
  Box,
} from "@mui/material";
import styles from "../../entity-editor/EntityEditor.styles";
import React, { useState } from "react";
import { NumericTextField } from '../../numeric-text-field/NumericTextField';
import { LinkTextField } from '../../link-text-field/LinkTextField';
import { LatinTextField } from '../../latin-text-field/LatinTextField';
import ValidatedAccordion from './ValidatedAccordion';

const ObjectGeneralFieldsBlock = ({ onChange, objectFields, errors, canEditPrice, errorFields, setErrorFields }) => {
  const [expanded, setExpanded] = useState<null | "general_fields">("general_fields");
  return (
    <ValidatedAccordion
      title="General fields *"
      hasErrors={!errors.isFilledKadId || Object.values(errorFields).includes(true)}
      expanded={expanded === "general_fields"}
      onChange={(isExp) => setExpanded(isExp ? "general_fields" : null)}
    >
      <Box sx={styles.fieldHolder}>
        <Box sx={styles.fieldBlock}>
          <NumericTextField
            fullWidth
            required
            id="kadaster-id-object"
            label="Kadaster ID"
            type="text"
            name="kadaster_id"
            errorFields={errorFields.kadaster_id}
            setErrorFields={setErrorFields}
            margin="dense"
            value={objectFields?.kadaster_id}
            onChange={(e) => onChange("generalFields", "kadaster_id", e, -1)}
            error={!errors.isFilledKadId}
          />
          <LinkTextField
            fullWidth
            id="kadaster-link-object"
            label="Kadaster link"
            type="text"
            name="kadaster_url"
            errorFields={errorFields.kadaster_url}
            setErrorFields={setErrorFields}
            margin="dense"
            value={objectFields?.kadaster_url}
            onChange={(e) => onChange('generalFields', 'kadaster_url', e, -1)}
          />
        </Box>
        <Box sx={styles.fieldBlock}>
          <NumericTextField
            fullWidth
            id="price-object"
            label="Price"
            type="text"
            name="price"
            disabled={!canEditPrice}
            errorFields={errorFields.price}
            setErrorFields={setErrorFields}
            margin="dense"
            value={objectFields?.price}
            onChange={(e) => onChange("generalFields", "price", e, -1)}
          />
          <LatinTextField
            fullWidth
            id="restrictions-object"
            label="Restrictions"
            type="text"
            name="restrictions"
            errorFields={errorFields.restrictions}
            setErrorFields={setErrorFields}
            margin="dense"
            value={objectFields?.restrictions}
            onChange={(e) => onChange('generalFields', 'restrictions', e, -1)}
          />
        </Box>
      </Box>
    </ValidatedAccordion>
  );
};

export default ObjectGeneralFieldsBlock;
